export default __webpack_public_path__ + "static/media/sowmya.6b84d6e6.jpg";